module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Steven Vogel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Steven Vogel")]), _vm._v(" is a James B. Duke Professor Emeritus of biology at Duke University. His most recent books include "), _c('I', [_vm._v("Cats’ Paws and Catapults")]), _vm._v(" and "), _c('I', [_vm._v("Glimpses of Creatures in Their Physical Worlds")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LtM3r6/tc-custom/9780226859422.jpg?1722568553670",
      "alt": "This image is the cover for the book Life of a Leaf"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Life of a Leaf\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In its essence, science is a way of looking at and thinking about the world. In "), _c('i', [_vm._v("The Life of a Leaf,")]), _vm._v(" Steven Vogel illuminates this approach, using the humble leaf as a model. Whether plant or person, every organism must contend with its immediate physical environment, a world that both limits what organisms can do and offers innumerable opportunities for evolving fascinating ways of challenging those limits. Here, Vogel explains these interactions, examining through the example of the leaf the extraordinary designs that enable life to adapt to its physical world."), _c('br'), _c('br'), _vm._v(" In Vogel’s account, the leaf serves as a biological everyman, an ordinary and ubiquitous living thing that nonetheless speaks volumes about our environment as well as its own. Thus in exploring the leaf’s world, Vogel simultaneously explores our own."), _c('br'), _vm._v("A companion website with demonstrations and teaching tools can be found here: "), _c('a', {
    attrs: {
      "href": "http://www.press.uchicago.edu/sites/vogel/index.html"
    }
  }, [_vm._v("http://www.press.uchicago.edu/sites/vogel/index.html")]), _c('br'), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0